export enum ConfigViewType {
  button = 'Button',
  commonModuleVersionDropDown = 'CommonModuleVersionDropDown',
  condition = 'Condition',
  dropdown = 'Dropdown',
  dtmfDropDown = 'DtmfDropDown',
  exitComponent = 'ExitComponent',
  formListDropDown = 'FormListDropDown',
  formVersionsDropDown = 'FormVersionsDropDown',
  function = 'Function',
  hr = 'hr',
  input = 'Input',
  intentDropdown = 'IntentDropdown',
  oldItemList = 'OldItemList',
  label = 'Label',
  jsx = 'Jsx',
  keySwitch = 'KeySwitch',
  keyValue = 'KeyValue',
  menu = 'menu',
  plavSavedPromptKeyDropdown = 'PlavSavedPromptKeyDropdown',
  promptDropdown = 'PromptDropdown',
  promptTextarea = 'PromptTextarea',
  scopeHint = 'ScopeHint',
  slider = 'Slider',
  switch = 'Switch',
  textarea = 'Textarea'
}
